module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[28]515.6f9a504.woff2";